<template>
  <tr>
    <form-item-label label="メールアドレス" :required="true" />
    <complemented-text-form
      v-if="complementedTextOpened"
      :text="complementedText"
      @open="openForm"
      :editable="true"
    />

    <td v-if="!complementedTextOpened" colspan="3">
      <div
        class="m3-textbox m3p-textbox m3p-form__strong"
        :class="shouldDisplayError ? [`m3p-form__errorbox`] : null"
      >
        <text-field
          :id="fieldName"
          class="inquiry-form-textbox"
          :name="fieldName"
          type="email"
          placeholder="例：aaa@bb.com"
          :validator="validator"
          :dispatcher="dispatcher"
        />
        <error-message :name="fieldName" />
      </div>
    </td>
  </tr>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useFieldError } from 'vee-validate';
import ErrorMessage from '@component_path/pages/pc/positions/show/common_components/form_element/ErrorMessage';
import ComplementedTextForm from '@component_path/pages/pc/positions/show/common_components/form_element/ComplementedText';
import FormItemLabel from '@component_path/pages/pc/positions/show/common_components/form_element/FormItemLabel';
import TextField from '@component_path/pages/common/form/element/input';
import { useEmailField } from '@component_path/inquiry_form_common_module/custom_hook/Email';

const store = useStore();

const { validator, fieldName } = useEmailField(true);
const dispatcher = ref('positionInquiryMail/setEmail');
const shouldDisplayError = useFieldError(fieldName.value);

const complementedTextOpened = ref(false);

const complementedText = computed(
  () => store.state.positionInquiryMail.formData[fieldName.value]
);

const openForm = () => (complementedTextOpened.value = false);

onMounted(() => {
  if (!!complementedText.value) {
    complementedTextOpened.value = true;
  }
});
</script>
